import {
    REFERENCE_LINK_DESCRIPTION_MAX_LENGTH,
    REFERENCE_LINK_URL_MAX_LENGTH,
    REFERENCE_LINK_URL_PATTERN,
    REFERENCE_LINKS_MAX_COUNT,
} from '../constants';

const TRANSLATION_PREFIX = 'STATIC.PAGES.AI_CONTEXT.REFERENCE_LINKS.ERRORS';

export const ERROR_KEYS = {
    URL_REQUIRED: `${TRANSLATION_PREFIX}.URL_REQUIRED`,
    URL_INVALID_DOMAIN: `${TRANSLATION_PREFIX}.URL_INVALID_DOMAIN`,
    URL_TOO_LONG: `${TRANSLATION_PREFIX}.URL_TOO_LONG`,
    URL_DUPLICATE: `${TRANSLATION_PREFIX}.URL_DUPLICATE`,
    DESCRIPTION_TOO_LONG: `${TRANSLATION_PREFIX}.DESCRIPTION_TOO_LONG`,
    MAX_LINKS: `${TRANSLATION_PREFIX}.MAX_LINKS`,
};

export const parseLinks = value => {
    if (!value) return [];
    try {
        const parsed = JSON.parse(value);
        if (!Array.isArray(parsed)) return [];
        return parsed
            .filter(entry => entry && typeof entry === 'object')
            .map(entry => ({
                url: typeof entry.url === 'string' ? entry.url : '',
                description: typeof entry.description === 'string' ? entry.description : '',
            }));
    } catch (e) {
        return [];
    }
};

export const validateRow = row => {
    const url = (row.url || '').trim();
    const description = row.description || '';

    if (!url) {
        return { url: ERROR_KEYS.URL_REQUIRED };
    }
    if (url.length > REFERENCE_LINK_URL_MAX_LENGTH) {
        return { url: ERROR_KEYS.URL_TOO_LONG };
    }
    if (!REFERENCE_LINK_URL_PATTERN.test(url)) {
        return { url: ERROR_KEYS.URL_INVALID_DOMAIN };
    }
    if (description.length > REFERENCE_LINK_DESCRIPTION_MAX_LENGTH) {
        return { description: ERROR_KEYS.DESCRIPTION_TOO_LONG };
    }
    return {};
};

export const validateRows = rows => {
    const seenUrls = new Set();
    return rows.map(row => {
        const errors = validateRow(row);
        const trimmedUrl = (row.url || '').trim();
        if (errors.url || !trimmedUrl) {
            return errors;
        }
        if (seenUrls.has(trimmedUrl)) {
            return { ...errors, url: ERROR_KEYS.URL_DUPLICATE };
        }
        seenUrls.add(trimmedUrl);
        return errors;
    });
};

export const hasAtLeastOneValidLink = value => {
    const rows = parseLinks(value);
    return validateRows(rows).some(errors => !errors.url && !errors.description);
};

export const buildLinksExportRows = value => {
    const rows = parseLinks(value);
    return rows
        .map(row => ({
            url: (row.url || '').trim(),
            description: (row.description || '').trim(),
        }))
        .filter(row => row.url);
};

export const isAtMaxLinks = rows => rows.length >= REFERENCE_LINKS_MAX_COUNT;
